<div class="col-md-12 mb-3">
  <div class="card p-3 shadow-sm">
    <h1 class="head1">Users</h1>
    <div class="row mb-3">
      <div class="col-md-12">
        <div class="float-end ms-2" *ngIf="!userValidation">
          <button routerLink="/user/create" class="btn btn-primary-sa btn-sm">
            Add User
          </button>
        </div>
        <!-- <div class="float-end ms-2">
          <button class="btn btn-primary-sa btn-sm" (click)="clearFilter()">
            Clear
          </button>
        </div> -->
        <!-- <form (ngSubmit)="onSearch()" #searchForm="ngForm">
          <div class="float-end ms-2">
            <button class="btn btn-primary-sa btn-sm">Search</button>
          </div>
          <div class="float-end ms-2">
            <input
              type="text"
              placeholder="Name/Email"
              [(ngModel)]="searchKey"
              name="searchKey"
              class="form-control"
              placeholder="Search"
            />
          </div>
          <div class="float-end">
            <label for="inputPassword6" class="col-form-label">Search By</label>
          </div>
        </form> -->
      </div>
    </div>

    <div class="table-scroll">
      <table width="100%" class="table table-striped">
        <thead>
          <tr>
            <th>Sr No</th>
            <th>Name</th>
            <th>Email</th>
            <th>Date of Birth</th>
            <th>Gender</th>
            <th>Phone Number</th>
            <th>Created Date</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="users.length > 0; else noUserList">
            <tr *ngFor="let user of users; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ user.name }}</td>
              <td>
                <a href="javascript:void(0);" class="email-link">{{
                  user.email
                }}</a>
              </td>
              <td>{{ user.dob }}</td>
              <td>{{ user.gender }}</td>
              <td>{{ formatContactNumber(user.phone_no.toString()) }}</td>
              <td>{{ user.created_on | date : "dd-MM-yyyy HH:mm" }}</td>
              <td>
                <div class="action-btn-table" *ngIf="loggedUser.id != user?.id">
                  <a
                    href="javascript:void(0);"
                    [routerLink]="['/user/edit', user?.id]"
                    title="Edit details of '{{ user.name }}'"
                    ><i class="fas fa-edit"></i
                  ></a>
                  <ng-container *ngIf="user.role !== projectAdminRole">
                    <a
                      href="javascript:void(0);"
                      (click)="confirmDelete(user?.id, user.name)"
                      title="Click here to delete '{{ user.name }}'"
                      ><i class="fa-solid fa-trash-can text-danger"></i
                    ></a>
                  </ng-container>
                  <a
                    class="text-success mx-1"
                    *ngIf="user.password_last_changed_on == null"
                    (click)="resendEmail(user)"
                    title="Resend user registration email"
                    style="cursor: pointer"
                  >
                    <i class="fa-solid fa-envelope"></i>
                  </a>
                </div>
              </td>
            </tr>
          </ng-container>
          <ng-template #noUserList>
            <tr>
              <td class="text-center font-weight-bold" colspan="100%">
                No User Found
              </td>
            </tr>
          </ng-template>
        </tbody>
      </table>
    </div>
  </div>
</div>
